import {
	BaseAPIResponse,
	CompanyCreateInfo,
	CompanyUpdateInfo,
	CreateCompanyAPIResponse,
	FilterCompaniesInput,
	GetAllRecruitersOfCompanyAPIResponse,
	GetBriefDebriefCallsResponse,
	GetCompanyByIdAPIResponse,
	GetCompanyBySearchAPIResponse,
	GetMyCompaniesAPIResponse,
	GetMyCompaniesListAPIResponse,
	GetScrapedPositionRecommendationsAPIResponse,
	LeadActionInput,
} from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseUrl = `${API_ENDPOINT}/company`;
export const createCompany = async (payload: CompanyCreateInfo): Promise<CreateCompanyAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/create`, { createInfo: payload });
	return response.data;
};

export const getCompanyById = async (id: string): Promise<GetCompanyByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/${id}`);
	return response.data;
};

export const getCompanyBySearch = async (payload: {
	search?: string;
	id?: string;
}): Promise<GetCompanyBySearchAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/find`, { params: payload });
	return response.data;
};

export const getRecruitersOfCompany = async (id: string): Promise<GetAllRecruitersOfCompanyAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/get-all-recruiters/${id}`);
	return response.data;
};

export const editCompany = async (args: { id: string; payload: CompanyUpdateInfo }): Promise<BaseAPIResponse> => {
	const { id, payload } = args;
	const response = await baseApi.patch(`${baseUrl}/${id}`, { updateInfo: payload });
	return response.data;
};

export const getMyCompaniesQuery = async (payload: FilterCompaniesInput): Promise<GetMyCompaniesAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/account-manager/my`, {
		params: payload,
	});
	return response.data;
};

export const getMyCompaniesListQuery = async (payload: string): Promise<GetMyCompaniesListAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/list/my`, {
		params: { name: payload },
	});
	return response.data;
};

export const getScrapedPositionRecommendationDetails = async (payload: {
	companyId: string;
}): Promise<GetScrapedPositionRecommendationsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/scraped-position-recommendation`, { params: payload });
	return response.data;
};
export const takeActionOnLead = async (payload: LeadActionInput): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/lead-action`, payload);
	return response.data;
};

export const getBriefDebriefCalls = async (payload: {
	companyId?: string;
	page?: number;
	limit?: number;
	showRequested?: boolean;
}): Promise<GetBriefDebriefCallsResponse> => {
	const response = await baseApi.get(`${baseUrl}/get-brief-debriefs`, { params: payload });
	return response.data;
};
